import { AppState, UrlPartSerializer } from '@immosky/types';
import { TypedAction } from '@ngrx/store/src/models';
import { setRadiusFilterBasedOnUrlValue } from './radius.actions';

export class RadiusFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    return setRadiusFilterBasedOnUrlValue({
      value: parseInt(urlValue, 10),
    });
  }

  serialize(state: AppState): string {
    const radiusFilter = state.filter.radius.filter;
    return `${radiusFilter.value}`;
  }
}
